module.exports = __webpack_public_path__ + "img/goldregen-2020-131.fbd77912.jpg";